{
  "version": 1,
  "packs": [
    {
      "id": "mild",
      "name": "温和",
      "tier": 0,
      "cards": [
        { "id": "mild-001", "text": "用一句话夸夸你右手边的人，要真诚。", "tags": ["破冰"], "intensity": 1 },
        { "id": "mild-002", "text": "说出你今天做过的最后一件好事。", "tags": ["真心话"], "intensity": 1 },
        { "id": "mild-003", "text": "模仿一种动物的叫声，让全场猜是什么。", "tags": ["表演", "搞怪"], "intensity": 1 },
        { "id": "mild-004", "text": "给大家表演一个你拿手的表情。", "tags": ["表演", "搞怪"], "intensity": 1 },
        { "id": "mild-005", "text": "说出你手机里最近拍的一张照片是什么。", "tags": ["真心话"], "intensity": 1 },
        { "id": "mild-006", "text": "用三个词形容你此刻的心情。", "tags": ["真心话", "破冰"], "intensity": 1 },
        { "id": "mild-007", "text": "讲一个冷笑话，冷到大家打哆嗦为止。", "tags": ["搞怪", "表演"], "intensity": 2 },
        { "id": "mild-008", "text": "原地做十个深蹲，边做边数出声。", "tags": ["体能"], "intensity": 2 },
        { "id": "mild-009", "text": "说出你童年最难忘的一件小事。", "tags": ["真心话"], "intensity": 1 },
        { "id": "mild-010", "text": "给现场每个人取一个可爱的外号。", "tags": ["破冰", "搞怪"], "intensity": 2 },
        { "id": "mild-011", "text": "唱两句你最熟的歌，跑调也没关系。", "tags": ["表演"], "intensity": 2 },
        { "id": "mild-012", "text": "说说你最近一次笑到肚子疼是因为什么。", "tags": ["真心话"], "intensity": 1 },
        { "id": "mild-013", "text": "闭眼转三圈，然后指出北方在哪儿。", "tags": ["体能", "搞怪"], "intensity": 2 },
        { "id": "mild-014", "text": "用最慢的语速说一句绕口令。", "tags": ["表演", "搞怪"], "intensity": 2 },
        { "id": "mild-015", "text": "现场学一句你家乡的方言。", "tags": ["表演", "破冰"], "intensity": 1 },
        { "id": "mild-016", "text": "说出你最想立刻去的一座城市。", "tags": ["真心话"], "intensity": 1 },
        { "id": "mild-017", "text": "坦承你身上一个无伤大雅的小习惯。", "tags": ["真心话", "破冰"], "intensity": 2 },
        { "id": "mild-018", "text": "用左手写下一个成语，让大家辨认。", "tags": ["搞怪", "表演"], "intensity": 2 },
        { "id": "mild-019", "text": "给大家分享一个只有你懂的梗。", "tags": ["搞怪", "破冰"], "intensity": 1 },
        { "id": "mild-020", "text": "说你最近学会的一件新技能。", "tags": ["真心话"], "intensity": 1 },
        { "id": "mild-021", "text": "模仿一下你朋友最常做的动作。", "tags": ["表演", "搞怪"], "intensity": 2 },
        { "id": "mild-022", "text": "说出你今天最想感谢的一个人。", "tags": ["真心话"], "intensity": 1 },
        { "id": "mild-023", "text": "用一句话总结你这一周，必须押韵。", "tags": ["表演", "搞怪"], "intensity": 2 },
        { "id": "mild-024", "text": "让大家看看你口袋或包里的一件小物。", "tags": ["破冰", "搞怪"], "intensity": 2 },
        { "id": "mild-025", "text": "说一个你至今没实现的童年愿望。", "tags": ["真心话"], "intensity": 1 },
        { "id": "mild-026", "text": "憋笑十秒，笑了就再讲一个笑话。", "tags": ["搞怪", "体能"], "intensity": 2 },
        { "id": "mild-027", "text": "用播音腔念出你手机的一条通知。", "tags": ["表演", "搞怪"], "intensity": 2 },
        { "id": "mild-028", "text": "说出你最擅长的一道家常菜。", "tags": ["真心话"], "intensity": 1 },
        { "id": "mild-029", "text": "给下一轮的玩家起一个搞怪称号。", "tags": ["破冰", "搞怪"], "intensity": 1 },
        { "id": "mild-030", "text": "说出你心中最好笑的三个词。", "tags": ["搞怪", "真心话"], "intensity": 1 }
      ]
    },
    {
      "id": "flirty",
      "name": "暧昧",
      "tier": 1,
      "cards": [
        { "id": "flirty-001", "text": "凑近左边的人，认真看他眼睛三秒再移开。", "tags": ["靠近", "氛围"], "intensity": 3 },
        { "id": "flirty-002", "text": "用一句话夸对方，要让对方脸红。", "tags": ["夸赞", "调情"], "intensity": 2 },
        { "id": "flirty-003", "text": "对右手边的人说一句只有你们懂的话。", "tags": ["暗示", "调情"], "intensity": 2 },
        { "id": "flirty-004", "text": "说出你第一眼注意到对方身上的哪一点。", "tags": ["夸赞", "暗示"], "intensity": 2 },
        { "id": "flirty-005", "text": "用耳语的音量对身边的人说一句悄悄话。", "tags": ["靠近", "挑逗"], "intensity": 3 },
        { "id": "flirty-006", "text": "与左手边的人十指相扣，坚持十秒。", "tags": ["靠近", "氛围"], "intensity": 3 },
        { "id": "flirty-007", "text": "形容一下你理想中约会的样子。", "tags": ["氛围", "暗示"], "intensity": 2 },
        { "id": "flirty-008", "text": "说出你最喜欢的一种拥抱方式。", "tags": ["氛围", "调情"], "intensity": 2 },
        { "id": "flirty-009", "text": "对对面的人笑一笑，笑到他先移开视线。", "tags": ["挑逗", "氛围"], "intensity": 2 },
        { "id": "flirty-010", "text": "用三个词形容对方的魅力。", "tags": ["夸赞", "调情"], "intensity": 2 },
        { "id": "flirty-011", "text": "说出你被撩到时最藏不住的反应。", "tags": ["暗示", "氛围"], "intensity": 2 },
        { "id": "flirty-012", "text": "假装给身边的人整理一下衣领或头发。", "tags": ["靠近", "挑逗"], "intensity": 3 },
        { "id": "flirty-013", "text": "说出你心里最浪漫的一部电影片段。", "tags": ["氛围", "暗示"], "intensity": 2 },
        { "id": "flirty-014", "text": "对着右手边的人念一句情话，要看着他的眼。", "tags": ["调情", "靠近"], "intensity": 3 },
        { "id": "flirty-015", "text": "说出你最近一次心跳加速是什么时候。", "tags": ["调情", "暗示"], "intensity": 2 },
        { "id": "flirty-016", "text": "问在场一个人一个你早就想问的问题。", "tags": ["暗示", "氛围"], "intensity": 2 },
        { "id": "flirty-017", "text": "用最温柔的语气叫一声对方的名字。", "tags": ["调情", "夸赞"], "intensity": 3 },
        { "id": "flirty-018", "text": "说出你最想收到的一份礼物。", "tags": ["暗示", "氛围"], "intensity": 2 },
        { "id": "flirty-019", "text": "和身边的人背靠背坐十秒，不许说话。", "tags": ["靠近", "氛围"], "intensity": 3 },
        { "id": "flirty-020", "text": "说出你觉得哪种距离刚刚好。", "tags": ["暗示", "氛围"], "intensity": 2 },
        { "id": "flirty-021", "text": "对左边的人说一句你若即若离的暗示。", "tags": ["暗示", "挑逗"], "intensity": 3 },
        { "id": "flirty-022", "text": "说出你最容易被哪种声音打动。", "tags": ["调情", "暗示"], "intensity": 2 },
        { "id": "flirty-023", "text": "形容一下你心里好看的侧脸是什么样。", "tags": ["夸赞", "氛围"], "intensity": 2 },
        { "id": "flirty-024", "text": "让右手边的人替你选一个答案，你必须接受。", "tags": ["挑逗", "靠近"], "intensity": 3 },
        { "id": "flirty-025", "text": "说出你最想在深夜和谁聊天。", "tags": ["暗示", "调情"], "intensity": 3 },
        { "id": "flirty-026", "text": "用一句话说出对面那个人给你的第一印象。", "tags": ["夸赞", "氛围"], "intensity": 2 },
        { "id": "flirty-027", "text": "和对面的人对视，先笑的人罚一杯。", "tags": ["挑逗", "氛围"], "intensity": 3 },
        { "id": "flirty-028", "text": "说出你偷偷欣赏过的一个小细节。", "tags": ["暗示", "夸赞"], "intensity": 2 },
        { "id": "flirty-029", "text": "给对方一个只差一点点的拥抱，然后停住。", "tags": ["靠近", "挑逗"], "intensity": 3 },
        { "id": "flirty-030", "text": "说出你最想被谁轻轻拍一下头顶。", "tags": ["挑逗", "氛围"], "intensity": 3 }
      ]
    }
  ]
}
